import toast from "@markaaz/ui/MzToast";
import * as api from "api/endpoints/portfolio";
import { createSlice, createSliceSelector } from "../factory";
import { loadPortfolios } from "./app";

const name = "portfolioPage";

const initialState = {
  data: null,
  addPortfolioRow: null,
  pageNo: 1
};

const slice = createSlice(name, initialState);

export default slice.reducer;

/* Selectors */
const createSelector = createSliceSelector(name);

export const selectPortfolioData = createSelector((state) => {
  return state.data;
});

export const selectPageNo = createSelector((state) => {
  return state.pageNo;
});

export const selectAddPortfolioRow = createSelector((state) => {
  return state.addPortfolioRow;
});

/* Actions */
const { update } = slice.actions;

export function loadPorfolioData(pageNo = 1) {
  const config = { params: { pageNo, pageSize: 5 } };
  return async function (dispatch) {
    return api.getFiles(config).then((res) => {
      const payload = { data: res, pageNo: pageNo };
      dispatch(update(payload));
    });
  };
}

export function deleteReport(id) {
  return async function (dispatch, getState) {
    const page = selectPageNo(getState());
    return api.remove(id).then(() => {
      dispatch(loadPorfolioData(page));
    });
  };
}

export function uploadReport(data) {
  return async function (dispatch, getState) {
    const page = selectPageNo(getState());
    return api.uploadFile(data).then(() => {
      dispatch(loadPorfolioData(page));
    });
  };
}

export function addPortfolioName(data) {
  return async function (dispatch, getState) {
    const page = selectPageNo(getState());
    return api
      .addPortfolioName(data)
      .then(() => {
        dispatch(loadPorfolioData(page));
        toast.show("Portfolio added successfully");
        const payload = { addPortfolioRow: null };
        dispatch(update(payload));
        dispatch(loadPortfolios());
      })
      .catch(() => {
        toast.show("Entered Portfolio name already exists", { severity: "error" });
      });
  };
}

export function removePortfolioName(id) {
  return async function (dispatch, getState) {
    const page = selectPageNo(getState());
    return api.removePortfolioName(id).then(() => {
      dispatch(loadPorfolioData(page));
    });
  };
}

export function setAddPortfolioRow(row) {
  return async function (dispatch) {
    const payload = { addPortfolioRow: row };
    dispatch(update(payload));
  };
}
